import { Button, Box } from '@mui/material';
import { MouseEventHandler } from 'react';
import { SxClassProps } from '@/types/common';
import FixElementToBottom from '@/components/FixElementToBottom';
import { createPortal } from 'react-dom';

interface StickyCTAButtonProps {
  onClick: MouseEventHandler<HTMLButtonElement>;
  isDisabled?: boolean;
  ctaText: string;
  removeContainerElementFromDOM?: boolean;
}

const classes: SxClassProps = {
  button: {
    width: {
      xs: '327px',
    },
  },
};

const StickyCTAButton = ({
  onClick,
  isDisabled,
  ctaText,
  removeContainerElementFromDOM,
}: StickyCTAButtonProps) => {
  return (
    <>
      <FixElementToBottom
        hasCenter
        forceFloat
        useFullWidthMW
        isAlwaysFixedToBottom
        removeContainerElementFromDOM={removeContainerElementFromDOM}>
        <Box textAlign="center" data-testid="sticky-cta-button">
          <Button
            variant="contained"
            color="primary"
            size="large"
            sx={classes.button}
            onClick={onClick}
            disabled={isDisabled}>
            {ctaText}
          </Button>
        </Box>
      </FixElementToBottom>
      {/*
       * create spacing to scroll past footer. This is a temporary solution.
       * If growth-enrollment-seeker-overhaul-cc-m1 test variant wins,
       * we should remove createPortal and add a wrapper around the Footer component in _app.tsx
       */}
      {createPortal(
        <Box sx={(theme) => ({ backgroundColor: theme.palette.background.grey, pb: 10 })} />,
        document.body
      )}
    </>
  );
};

StickyCTAButton.defaultProps = {
  isDisabled: false,
  removeContainerElementFromDOM: false,
};

export default StickyCTAButton;
